import { createSlice } from "@reduxjs/toolkit";
import { updateSalesTags, teamLeaderRequestForm, fetchRepSalesRecordings } from "./SalesActions";

const initialState = {
  loading: false,
  repSalesRecordings: {
    data: null,
    loading: false,
    error: null,
  },
};

const salesSlice = createSlice({
  name: "sales",
  initialState,
  reducers: {
    clearRepSalesRecordings: (state) => {
      state.repSalesRecordings = {
        data: null,
        loading: false,
        error: null,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateSalesTags.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateSalesTags.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateSalesTags.rejected, (state) => {
        state.loading = false;
      })
      .addCase(teamLeaderRequestForm.pending, (state) => {
        state.loading = true;
      })
      .addCase(teamLeaderRequestForm.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(teamLeaderRequestForm.rejected, (state) => {
        state.loading = false;
      })
      // Rep Sales Recordings
      .addCase(fetchRepSalesRecordings.pending, (state) => {
        state.repSalesRecordings.loading = true;
        state.repSalesRecordings.error = null;
      })
      .addCase(fetchRepSalesRecordings.fulfilled, (state, { payload }) => {
        state.repSalesRecordings.data = payload;
        state.repSalesRecordings.loading = false;
        state.repSalesRecordings.error = null;
      })
      .addCase(fetchRepSalesRecordings.rejected, (state, { payload }) => {
        state.repSalesRecordings.loading = false;
        state.repSalesRecordings.error = payload || "Failed to fetch rep sales recordings";
      });
  },
});

export const { clearRepSalesRecordings } = salesSlice.actions;
export default salesSlice.reducer;
